import React, { useState } from "react";
import "./MySkills.css";
import html from "../../images/assets/html.png";
import css from "../../images/assets/css.png";
import js from "../../images/assets/js.png";
import ts from "../../images/assets/ts.png";
import react from "../../images/assets/react.png";
import tailwind from "../../images/assets/tailwind.png";
import bootstrap from "../../images/assets/bootstrap.png";
import material from "../../images/assets/material.png";
import shadcn from "../../images/assets/shadcn.png";
import matTail from "../../images/assets/mat-tail.png";
import nodejs from "../../images/assets/nodejs.png";
import express from "../../images/assets/express.png";
import php from "../../images/assets/php.png";
import laravel from "../../images/assets/laravel.png";
import mysql from "../../images/assets/mysql.png";
import mongo from "../../images/assets/mongo.png";

const MySkills = () => {
  const [activeTab, setActiveTab] = useState("frontend");

  const tabs = [
    { name: "Frontend", key: "frontend" },
    { name: "Backend", key: "backend" },
    { name: "Database", key: "database" },
    { name: "Tools", key: "tools" },
    { name: "App Development", key: "appDevelopment" },
  ];

  const skillCategories = {
    frontend: [
      { name: "HTML", color: "bg-[#e44d26]", src: html },
      { name: "CSS", color: "bg-[#1b73ba]", src: css },
      { name: "Javascript", color: "bg-[#e4a125]", src: js },
      { name: "Typescript", color: "bg-[#007acc]", src: ts },
      { name: "React Js", color: "bg-[#00d8ff]", src: react, rounded: true },
      { name: "Tailwind Css", color: "bg-[#14c4b7]", src: tailwind },
      { name: "Bootstrap", color: "bg-[#6b19fb]", src: bootstrap },
      { name: "Material Ui", color: "bg-[#0080ff] text-white", src: material, rounded: true },
      { name: "Shadcn Ui", color: "bg-[#0e1214] text-white", src: shadcn, rounded: true },
      { name: "Material Tailwind", color: "bg-[#0b0b0b] text-white", src: matTail, rounded: true },
    ],
    backend: [
      { name: "NODEJS", color: "bg-[#559944]", src: nodejs, rounded: true },
      { name: "Express Js", color: "bg-[#3a3a3a]", src: express, rounded: true },
      { name: "Php", color: "bg-[#777bb3]", src: php },
      { name: "Laravel", color: "bg-[#ff2d20] text-white", src: laravel, rounded: true },
    ],
    database: [
      { name: "MySql", color: "bg-[#e48e00]", src: mysql, rounded: true },
      { name: "Mongodb", color: "bg-[#599636]", src: mongo, rounded: true },
    ],
    tools: [
      // { name: "MySql", color: "bg-[#e48e00]", src: mysql, rounded: true },
      // { name: "Mongodb", color: "bg-[#599636]", src: mongo, rounded: true },
    ],
    appDevelopment: [
      // { name: "MySql", color: "bg-[#e48e00]", src: mysql, rounded: true },
      // { name: "Mongodb", color: "bg-[#599636]", src: mongo, rounded: true },
    ],
  };

  return (
    <div className="py-6 px-[8%] bg-gray-900 text-white shadow-md flex flex-col gap-5">
      <div className="border-b border-[#00A9FF] py-3 inline-flex justify-start">
  <h1 className="text-2xl sm:text-3xl font-bold text-[#00A9FF] tracking-wide">💡 Skilled In</h1>
</div>


      <div className="relative mx-auto w-auto max-w-full rounded-xl shadow shadow-[#00A9FF]">
  <div className="flex space-x-4 px-6 border-[#00A9FF] border mx-auto py-2 rounded-xl bg-gray-700 border-b pb-2 overflow-x-auto whitespace-nowrap flex-nowrap scrollbar-hidden" style={{ WebkitOverflowScrolling: "touch" }}>
    {tabs.map((tab) => (
      <button
        key={tab.key}
        onClick={() => setActiveTab(tab.key)}
        className={`px-3 py-1 text-base font-bold text-white rounded-md transition ${
          activeTab === tab.key ? "bg-[#00A9FF] text-white" : "bg-gray-700"
        }`}
      >
        {tab.name}
      </button>
    ))}
  </div>
</div>


      <div className="grid grid-cols-2 sm:flex sm:flex-row sm:flex-wrap items-center justify-center gap-4 mt-4">
  {skillCategories[activeTab] && skillCategories[activeTab].length > 0 ? (
    skillCategories[activeTab].map(({ name, color, src, rounded }, index) => (
      <div
        key={index}
        className={`flex flex-row items-center justify-center gap-2 ${color} text-white font-bold p-3 shadow-md border rounded-lg`}
      >
        <img
          src={src}
          className={`h-10 md:h-14 lg:h-16 w-10 md:w-14 lg:w-16 object-cover ${rounded ? "rounded-full" : ""}`}
          alt={name}
        />
        <h1 className="text-xs md:text-sm lg:text-base">{name}</h1>
      </div>
    ))
  ) : (
    <p className="text-center text-gray-400 text-lg w-full">No data available</p>
  )}
</div>

    </div>
  );


};

export default MySkills;
